import { FC, useEffect, useRef } from 'react'

import { useNavigate, useSearchParams } from 'react-router-dom'

import { useNotifications, Center } from '@sequencehq/core-components'
import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'

import Spinner from 'components/Loading'

export const GoCardlessRedirect: FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { displayNotification } = useNotifications()
  const hasRun = useRef(false)

  useEffect(() => {
    if (hasRun.current) {
      return
    }
    hasRun.current = true

    const code = searchParams.get('code')
    const state = searchParams.get('state')

    if (!code || !state) {
      displayNotification('Failed to connect to GoCardless', {
        type: 'error'
      })
      navigate('/home')
      return
    }

    void dashboardv20240509Client
      .postAuthorizeComplete({
        service: 'GoCardless',
        code,
        state
      })
      .then(response => {
        if (response.error || !response.data) {
          displayNotification('Failed to connect to GoCardless', {
            type: 'error'
          })
          navigate('/home')
          return
        }

        displayNotification('Successfully connected to GoCardless', {
          type: 'success'
        })
        navigate('/integration-management/GoCardless?authorized=true')
      })
  }, [searchParams, navigate, displayNotification])

  return (
    <Center height="100vh">
      <Spinner />
    </Center>
  )
}
